/**
 * Modelos prontos de templates para campanhas de Email e WhatsApp.
 * Usados no TemplateModal para facilitar a criação de novos templates.
 */

export const templateModels = [
  // ── EMAIL ──────────────────────────────────────────────
  {
    categoria: 'Boas-vindas',
    canal: 'email',
    nome: 'Boas-vindas - Novo Paciente',
    assunto: 'Bem-vinda(o) ao consultório NutriBruna, {primeiro_nome}!',
    corpo: `Olá {primeiro_nome},

Seja muito bem-vinda(o) ao nosso consultório de nutrição!

Estou muito feliz em ter você como paciente. A partir de agora, vamos trabalhar juntos para alcançar seus objetivos de saúde e bem-estar.

Algumas informações importantes:
- Suas consultas serão sempre personalizadas
- Você receberá orientações práticas e acessíveis
- Estou disponível para tirar dúvidas entre as consultas

Se tiver qualquer dúvida, não hesite em entrar em contato.

Um abraço,
NutriBruna Barbosa`,
  },
  {
    categoria: 'Boas-vindas',
    canal: 'email',
    nome: 'Boas-vindas - Primeiro Passo',
    assunto: '{primeiro_nome}, seu primeiro passo rumo a uma vida mais saudável!',
    corpo: `Olá {primeiro_nome}!

Parabéns por dar o primeiro passo em direção a uma alimentação mais saudável e equilibrada!

Aqui no consultório NutriBruna, acreditamos que nutrição vai muito além de dietas restritivas. Nosso foco é criar um plano alimentar que se encaixe na sua rotina e que você consiga manter com prazer.

O que esperar:
- Avaliação completa do seu perfil nutricional
- Plano alimentar personalizado
- Acompanhamento contínuo da sua evolução

Estou ansiosa para começar essa jornada com você!

Abraços,
NutriBruna Barbosa`,
  },

  // ── RETORNO / LEMBRETE ─────────────────────────────────
  {
    categoria: 'Retorno',
    canal: 'email',
    nome: 'Lembrete de Retorno',
    assunto: '{primeiro_nome}, está na hora do seu retorno!',
    corpo: `Olá {primeiro_nome},

Espero que esteja bem! Passando para lembrar que já faz um tempo desde a nossa última consulta.

O acompanhamento regular é fundamental para:
- Avaliar sua evolução
- Ajustar o plano alimentar conforme necessário
- Manter a motivação em alta

Que tal agendarmos seu retorno? Entre em contato para marcarmos o melhor horário para você.

Te espero!
NutriBruna Barbosa`,
  },
  {
    categoria: 'Retorno',
    canal: 'email',
    nome: 'Reengajamento - Paciente Inativo',
    assunto: 'Sentimos sua falta, {primeiro_nome}!',
    corpo: `Olá {primeiro_nome},

Faz um tempinho que não nos vemos e queria saber como você está!

Sei que a rotina pode ficar corrida, mas lembre-se: cuidar da alimentação é cuidar de você.

Estou com horários disponíveis e adoraria retomar nosso acompanhamento. Mesmo que seus objetivos tenham mudado, posso ajudar com um novo plano adaptado à sua realidade atual.

Vamos remarcar?

Com carinho,
NutriBruna Barbosa`,
  },

  // ── DICAS / CONTEUDO ───────────────────────────────────
  {
    categoria: 'Dicas',
    canal: 'email',
    nome: 'Dicas de Alimentação Saudável',
    assunto: '{primeiro_nome}, 5 dicas práticas para o seu dia a dia!',
    corpo: `Olá {primeiro_nome}!

Separei 5 dicas rápidas para melhorar sua alimentação no dia a dia:

1. Comece o dia com um copo de água antes do café da manhã
2. Inclua pelo menos 3 porções de vegetais nas refeições
3. Prefira frutas inteiras ao invés de sucos
4. Faça pequenos lanches entre as refeições principais
5. Evite comer distraído (celular, TV)

Pequenas mudanças fazem grande diferença ao longo do tempo!

Se quiser um plano mais detalhado, estou à disposição.

Abraços,
NutriBruna Barbosa`,
  },
  {
    categoria: 'Dicas',
    canal: 'email',
    nome: 'Dicas Sazonais - Inverno',
    assunto: '{primeiro_nome}, como manter a alimentação saudável no inverno',
    corpo: `Olá {primeiro_nome}!

Com a chegada do frio, é comum sentir mais vontade de comer alimentos calóricos. Aqui vão algumas dicas para manter o equilíbrio:

- Aposte em sopas e caldos nutritivos com legumes
- Chás e infusões ajudam a manter a hidratação
- Frutas da estação: morango, kiwi, tangerina e abacate
- Prefira preparações assadas ao invés de fritas
- Mantenha a atividade física mesmo nos dias frios

O inverno pode ser uma ótima época para fortalecer hábitos saudáveis!

Abraços quentinhos,
NutriBruna Barbosa`,
  },

  // ── ANIVERSARIO ────────────────────────────────────────
  {
    categoria: 'Aniversario',
    canal: 'email',
    nome: 'Feliz Aniversário',
    assunto: 'Feliz Aniversário, {primeiro_nome}!',
    corpo: `Querida(o) {primeiro_nome},

Hoje é um dia especial e eu não poderia deixar de parabenizá-la(o)!

Desejo um ano repleto de saúde, alegria e conquistas. Que você continue cuidando de si com carinho e dedicação.

E sim, hoje pode comer aquele bolo com vontade! Amanhã a gente volta ao plano.

Feliz aniversário!

Com carinho,
NutriBruna Barbosa`,
  },

  // ── RESULTADO / MOTIVACAO ──────────────────────────────
  {
    categoria: 'Motivacional',
    canal: 'email',
    nome: 'Motivação - Celebrar Progresso',
    assunto: '{primeiro_nome}, olha o quanto você já evoluiu!',
    corpo: `Olá {primeiro_nome}!

Quero te lembrar de algo muito importante: olhe para trás e veja o quanto você já evoluiu!

Cada escolha saudável que você faz é uma vitória. Não importa se o progresso parece lento — o que importa é a consistência.

Lembre-se:
- Comparar-se apenas consigo mesma(o) de ontem
- Celebrar cada pequena conquista
- Respeitar o tempo do seu corpo

Estou muito orgulhosa do seu progresso e estou aqui para te apoiar sempre.

Vamos continuar juntas(os)!
NutriBruna Barbosa`,
  },

  // ── WHATSAPP ───────────────────────────────────────────
  {
    categoria: 'Boas-vindas',
    canal: 'whatsapp',
    nome: 'WhatsApp - Boas-vindas',
    corpo: `Oi {primeiro_nome}! Aqui é a NutriBruna Barbosa.

Seja bem-vinda(o) ao consultório! Estou muito feliz em te receber como paciente.

Vamos juntos nessa jornada por mais saúde e bem-estar. Se tiver qualquer dúvida, me chama por aqui!`,
  },
  {
    categoria: 'Retorno',
    canal: 'whatsapp',
    nome: 'WhatsApp - Lembrete de Retorno',
    corpo: `Oi {primeiro_nome}! Tudo bem?

Passando para lembrar que está na hora do seu retorno. O acompanhamento regular faz toda a diferença nos resultados!

Vamos agendar? Me manda uma mensagem com o melhor dia e horário para você.`,
  },
  {
    categoria: 'Retorno',
    canal: 'whatsapp',
    nome: 'WhatsApp - Reengajamento',
    corpo: `Oi {primeiro_nome}, tudo bem?

Faz um tempo que não nos vemos e queria saber como você está! Sentimos sua falta aqui no consultório.

Se quiser retomar o acompanhamento, estou com horários disponíveis. Vamos conversar?`,
  },
  {
    categoria: 'Dicas',
    canal: 'whatsapp',
    nome: 'WhatsApp - Dica Rápida',
    corpo: `Oi {primeiro_nome}! Dica rápida do dia:

Beba pelo menos 2 litros de água hoje! Uma boa hidratação melhora a disposição, a pele e até ajuda no controle do peso.

Dica: deixe uma garrafinha sempre por perto como lembrete.

Cuide-se!`,
  },
  {
    categoria: 'Dicas',
    canal: 'whatsapp',
    nome: 'WhatsApp - Dica de Receita',
    corpo: `Oi {primeiro_nome}! Que tal uma receita prática e saudável?

*Smoothie Verde Energizante*
- 1 banana congelada
- 1 punhado de espinafre
- 200ml de leite vegetal
- 1 colher de pasta de amendoim

Bata tudo no liquidificador. Pronto em 2 minutos!

Experimenta e me conta o que achou!`,
  },
  {
    categoria: 'Aniversario',
    canal: 'whatsapp',
    nome: 'WhatsApp - Aniversário',
    corpo: `Oi {primeiro_nome}!

Parabéns pelo seu dia! Desejo muita saúde, alegria e conquistas nesse novo ano.

Hoje é dia de celebrar! Aproveite sem culpa.

Feliz aniversário!
NutriBruna`,
  },
  {
    categoria: 'Motivacional',
    canal: 'whatsapp',
    nome: 'WhatsApp - Motivação',
    corpo: `Oi {primeiro_nome}!

Só passando para te lembrar: cada dia é uma nova chance de fazer escolhas melhores para a sua saúde.

Não busque perfeição, busque consistência. Você está indo muito bem!

Conte comigo sempre.`,
  },

  // ── AMBOS (Email + WhatsApp) ───────────────────────────
  {
    categoria: 'Informativo',
    canal: 'ambos',
    nome: 'Horário de Funcionamento',
    assunto: '{primeiro_nome}, confira nosso horário de atendimento',
    corpo: `Olá {primeiro_nome}!

Informamos nossos horários de atendimento:

Segunda a Sexta: 8h às 18h
Sábado: 8h às 12h

Para agendar ou remarcar consultas, entre em contato por telefone ou WhatsApp.

Atenciosamente,
NutriBruna Barbosa`,
  },
  {
    categoria: 'Informativo',
    canal: 'ambos',
    nome: 'Aviso de Recesso',
    assunto: 'Informativo: Recesso do Consultório',
    corpo: `Olá {primeiro_nome}!

Informamos que o consultório estará em recesso no período de [DATA INÍCIO] a [DATA FIM].

Retornaremos normalmente no dia [DATA RETORNO].

Para urgências durante o recesso, entre em contato por email.

Boas festas!
NutriBruna Barbosa`,
  },

  // ── IA ─────────────────────────────────────────────────
  {
    categoria: 'IA',
    canal: 'email',
    nome: 'IA - Email Personalizado Boas-vindas',
    assunto: 'Bem-vinda(o) ao consultório, {primeiro_nome}!',
    corpo: '',
    usar_ia: true,
    prompt_ia: `Escreva um email de boas-vindas caloroso e profissional para o paciente {primeiro_nome} {sobrenome}, que mora em {uf}.

O email deve:
- Ser acolhedor e empático
- Mencionar que estamos felizes em tê-lo(a) como paciente
- Dar uma breve introdução sobre o acompanhamento nutricional
- Finalizar com uma mensagem motivacional

Tom: profissional mas acolhedor. Máximo 150 palavras. Assine como NutriBruna Barbosa.`,
    modelo_ia: 'gpt-4.1-mini',
    temperatura: 0.8,
  },
  {
    categoria: 'IA',
    canal: 'whatsapp',
    nome: 'IA - WhatsApp Dica Personalizada',
    corpo: '',
    usar_ia: true,
    prompt_ia: `Escreva uma mensagem curta de WhatsApp com uma dica de nutrição personalizada para o paciente {primeiro_nome}, idade {idade}, do estado {uf}.

A mensagem deve:
- Ser curta (máximo 80 palavras)
- Incluir uma dica prática e fácil de aplicar
- Ser informal e amigável
- Não usar formatação HTML, apenas texto simples e emojis

Tom: leve e amigável. Assine como NutriBruna.`,
    modelo_ia: 'qwen-qwq-32b',
    temperatura: 0.9,
  },
  {
    categoria: 'IA',
    canal: 'email',
    nome: 'IA - Email Motivacional',
    assunto: '{primeiro_nome}, continue firme na sua jornada!',
    corpo: '',
    usar_ia: true,
    prompt_ia: `Escreva um email motivacional para o paciente {primeiro_nome} {sobrenome} sobre a importância de manter o acompanhamento nutricional.

O email deve:
- Ser inspirador e empático
- Falar sobre consistência e não perfeição
- Incluir 2-3 benefícios de manter o acompanhamento
- Convidar para agendar um retorno

Tom: motivacional e acolhedor. Máximo 120 palavras. Assine como NutriBruna Barbosa.`,
    modelo_ia: 'gpt-4.1-mini',
    temperatura: 0.7,
  },
  {
    categoria: 'IA',
    canal: 'email',
    nome: 'IA - Email Dicas Personalizadas',
    assunto: '{primeiro_nome}, dicas especiais de nutrição para você!',
    corpo: '',
    usar_ia: true,
    prompt_ia: `Escreva um email com 3 dicas de nutrição personalizadas para o paciente {primeiro_nome} {sobrenome}, idade {idade}, do estado {uf}.

O email deve:
- Trazer dicas práticas e aplicáveis no dia a dia
- Considerar o perfil do paciente
- Ter uma linguagem acessível e motivadora
- Finalizar convidando para uma consulta

Tom: educativo e simpático. Máximo 180 palavras. Assine como NutriBruna Barbosa.`,
    modelo_ia: 'gpt-4.1-mini',
    temperatura: 0.8,
  },
  {
    categoria: 'IA',
    canal: 'whatsapp',
    nome: 'IA - WhatsApp Motivacional',
    corpo: '',
    usar_ia: true,
    prompt_ia: `Escreva uma mensagem motivacional curta de WhatsApp para o paciente {primeiro_nome}, idade {idade}.

A mensagem deve:
- Ser curta (máximo 60 palavras)
- Motivar a manter hábitos saudáveis
- Ser positiva e encorajadora
- Usar emojis com moderação

Tom: amigável e motivador. Assine como NutriBruna.`,
    modelo_ia: 'qwen-qwq-32b',
    temperatura: 0.8,
  },
]

/**
 * Retorna categorias únicas disponíveis.
 */
export function getCategorias() {
  return [...new Set(templateModels.map((t) => t.categoria))]
}

/**
 * Filtra modelos por canal.
 */
export function getModelosPorCanal(canal) {
  if (!canal) return templateModels
  return templateModels.map((t) => t.canal === canal || t.canal === 'ambos')
}

/**
 * Filtra modelos por categoria.
 */
export function getModelosPorCategoria(categoria) {
  if (!categoria) return templateModels
  return templateModels.filter((t) => t.categoria === categoria)
}
